import {
  BookOpen,
  Home,
  Library,
  NotebookPen,
  RefreshCcw,
  Target,
  type LucideIcon,
} from "lucide-react";
import { DEFAULT_COURSE_ID } from "@/lib/config";

export interface PrimaryNavItem {
  href: string;
  label: string;
  icon: LucideIcon;
  activePrefixes: string[];
  desktop: boolean;
}

export const PRIMARY_NAV_ITEMS: PrimaryNavItem[] = [
  { href: "/", label: "首页", icon: Home, activePrefixes: ["/"], desktop: true },
  {
    href: `/courses/${DEFAULT_COURSE_ID}`,
    label: "课程",
    icon: BookOpen,
    activePrefixes: ["/courses/", "/concepts/", "/map"],
    desktop: true,
  },
  { href: "/reading", label: "阅读", icon: Library, activePrefixes: ["/reading"], desktop: true },
  { href: "/quiz", label: "练习", icon: Target, activePrefixes: ["/quiz"], desktop: true },
  { href: "/review", label: "复习", icon: RefreshCcw, activePrefixes: ["/review"], desktop: true },
  { href: "/notes", label: "笔记", icon: NotebookPen, activePrefixes: ["/notes"], desktop: true },
];

export function isPrimaryNavActive(pathname: string, item: PrimaryNavItem): boolean {
  if (item.href === "/") return pathname === "/";
  return item.activePrefixes.some((prefix) => pathname.startsWith(prefix));
}
